import React from 'react';
import ComingSoon from '../../../components/ComingSoon';

const Sharing: React.FC = () => {
  return (
    <div className="shadow rounded-lg bg-white">
      <ComingSoon
        label={`On it's way`}
        title="Sharing"
        description={`Sharing your listing should be easy. We're building the features you'll need to be able to push your listing to anyone with one click.`}
      />
    </div>
  );
};

export default Sharing;
